import enrolLoyaltyAccount from 'actions/loyalty/enrolLoyaltyAccount'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useCallback } from 'react'
import LoyaltyLandingPageUSPSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageUSPSection'
import LoyaltyLandingPageHowItWorksSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageHowItWorksSection'
import useLoyaltyUserEligibilityTier from 'loyalty/hooks/useLoyaltyUserEligibilityTier'
import LoyaltyUserBronzeHero from './LoyaltyUserBronzeHero'
import LoyaltyUserSilverHero from './LoyaltyUserSilverHero'
import LoyaltyUserGoldHero from './LoyaltyUserGoldHero'
import LoyaltyLandingPageBenefitsTableSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageBenefitsTableSection'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import LoyaltyLandingPageDiscoverTiersSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageDiscoverTiersSection'
import LoyaltyWhatsNewCarousel from '../loyaltyLandingPageSharedSections/LoyaltyWhatsNewCarousel'
import LoyaltyLandingPageFaqSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageFaqSection'
import LoyaltyUserBronzeBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserBronzeBenefits'
import LoyaltyUserGoldBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserGoldBenefits'
import LoyaltyUserSilverBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserSilverBenefits'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import getCanJoinLoyalty from 'loyalty/selectors/getCanJoinLoyalty'
import getIsLoyaltyAccountClosed from 'loyalty/selectors/getIsLoyaltyAccountClosed'
import getLoyaltyClosedAccountTier from 'loyalty/lib/getLoyaltyClosedAccountTier'
import LoyaltyUserClosedAccountHero from './LoyaltyUserClosedAccountHero'

function LoyaltyGuestLandingPage() {
  const dispatch = useAppDispatch()
  const [eligibilityTier, fetchingEligibility] = useLoyaltyUserEligibilityTier()
  const canJoinLoyalty = useAppSelector(getCanJoinLoyalty)
  const isLoyaltyAccountClosed = useAppSelector(getIsLoyaltyAccountClosed)
  // Infinite is invitational, so a closed Infinite member gets no tier marketing, as on the member page
  const isClosedInfiniteAccount = useAppSelector(state => getLoyaltyClosedAccountTier(state.loyalty.account.error) === 'infinite')
  const onJoinClick = useCallback(() => {
    dispatch(enrolLoyaltyAccount({ enrolment: 'existingUserRegistration' }))
  }, [dispatch])
  // A closed account has no eligibility tier, so none of the invite heroes or benefits show, and it
  // can't join again. It gets its own hero offering to reopen it instead.
  const onJoin = canJoinLoyalty ? onJoinClick : undefined

  if (fetchingEligibility) {
    return <LoadingIndicator />
  }

  return <div>
    {isLoyaltyAccountClosed && <LoyaltyUserClosedAccountHero />}
    {eligibilityTier === 'bronze' && <LoyaltyUserBronzeHero onActivate={onJoinClick} />}
    {eligibilityTier === 'silver' && <LoyaltyUserSilverHero onActivate={onJoinClick} />}
    {eligibilityTier === 'gold' && <LoyaltyUserGoldHero onActivate={onJoinClick} />}
    <LoyaltyLandingPageUSPSection />
    <Pane background="light-background">
      <LayoutContainer variant="medium">
        {eligibilityTier === 'bronze' && <LoyaltyUserBronzeBenefits onActivate={onJoinClick} />}
        {eligibilityTier === 'silver' && <LoyaltyUserSilverBenefits onActivate={onJoinClick} />}
        {eligibilityTier === 'gold' && <LoyaltyUserGoldBenefits onActivate={onJoinClick} />}
      </LayoutContainer>
    </Pane>
    <LoyaltyWhatsNewCarousel audienceLabel="Société" />
    {!isClosedInfiniteAccount && <LoyaltyLandingPageDiscoverTiersSection />}
    {!isClosedInfiniteAccount && <LoyaltyLandingPageBenefitsTableSection highlightTier={eligibilityTier} onJoin={onJoin} />}
    {!isClosedInfiniteAccount && <LoyaltyLandingPageHowItWorksSection onJoin={onJoin} />}
    <LoyaltyLandingPageFaqSection slug={isClosedInfiniteAccount ? 'societe-infinite-faqs' : 'societe-faqs'} />
  </div>
}

export default LoyaltyGuestLandingPage
